<template>
  <div>
    <!-- exibir anexos -->
    <div v-if="hasAttachments">
      <b-button v-if="!isShowingEveryAttachments" size="sm" @click="showAllAttachments">
        {{ $t("geral.showAllAttachments") }}
      </b-button>
      <b-button v-if="isShowingEveryAttachments" size="sm" @click="hideEveryAttachments">
        {{ $t("geral.hideAllAttachments") }}
      </b-button>
    </div>

    <!-- campos de resumo -->
    <div class="mb-4">
      <div v-for="summary in fields" :key="summary.fieldName">
        <filling-details-summary-field ref="summaryFieldComponent" :field="summary"
          @after-attachment-show="verifyShowingEveryAttachments">
        </filling-details-summary-field>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FillingDetailsSummaryFields",
  components: {
    'filling-details-summary-field': () => import("@/components_rms/workflow/WorkflowFilled/FillingDetails/FillingDetailsSummaryField.vue"),
  },
  props: {
    fields: Array,
  },
  data() {
    return {
      isShowingEveryAttachments: false,
    };
  },
  computed: {
    hasAttachments() {
      if (this.fields == null) return false;
      if (this.fields.length == 0) return false;
      for (let field of this.fields) {
        if (field.attachments.length > 0) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    hideEveryAttachments() {
      this.$refs.summaryFieldComponent.forEach((fieldComponent) => {
        fieldComponent.hideAttachment();
      });
      this.isShowingEveryAttachments = false;
    },
    showAllAttachments() {
      this.$refs.summaryFieldComponent.forEach((fieldComponent) => {
        fieldComponent.showAttachment();
      });
      this.isShowingEveryAttachments = true;
    },
    verifyShowingEveryAttachments() {
      let total = 0;
      let showing = 0;
      this.$refs.summaryFieldComponent.forEach((fieldComponent) => {
        if (fieldComponent.hasAttachments) {
          total++;
          if (fieldComponent.isShowingAttachment) {
            showing++;
          }
        }
      });
      this.isShowingEveryAttachments = total == showing;
    },
  },
};
</script>